import React from 'react';
import { motion } from 'framer-motion';
import { ImageIcon } from 'lucide-react';
const items = [{
  label: 'Lechada Impecable',
  image: 'https://cdn.magicpatterns.com/uploads/pmv52fcCLtWNS6tvMvY99j/lechada.webp'
}, {
  label: 'Azulejos Actualizados',
  image: 'https://cdn.magicpatterns.com/uploads/gy9CaeAXVrYWpTF2HQkvxj/azulejos.webp'
}, {
  label: 'Muebles Modernos',
  image: 'https://cdn.magicpatterns.com/uploads/4zWFYHg1nymMPMTmqwfCv5/muebles.jpg'
}, {
  label: 'Cocina Renovada',
  image: 'https://cdn.magicpatterns.com/uploads/9wx89i4EQ7PF6WBipcrQ1L/cocina.jpg'
}, {
  label: 'Pisos Rejuvenecidos',
  image: 'https://cdn.magicpatterns.com/uploads/wtNLGEL8E7ATYphHXhurg8/pisorejuvenecido.jpg'
}, {
  label: 'Paredes Prolijas',
  image: 'https://cdn.magicpatterns.com/uploads/dGn4DYjQ69CJFSaQu45Mai/paredesprolijas.jpg'
}, {
  label: 'Humedad Controlada',
  image: 'https://cdn.magicpatterns.com/uploads/eErBRmefRALgioV8RJH4iE/humedad.webp'
}, {
  label: 'Iluminación Estratégica',
  image: 'https://cdn.magicpatterns.com/uploads/9H3AmZZHnfyTgJXc5ggFWZ/iluminacion.jpg'
}];
export function WhatYouGet() {
  return <section className="py-8 md:py-12 px-4 md:px-6 lg:px-8 bg-lightgray" data-id="element-264">
      <div className="max-w-5xl mx-auto" data-id="element-265">
        <div className="text-center mb-5" data-id="element-266">
          <h2 className="text-2xl md:text-3xl font-black text-black tracking-tight" data-id="element-267">
            Todo lo que vas a poder transformar…
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3" data-id="element-268">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col p-2.5 border border-black/5" data-id="element-269">
              <div className="aspect-square rounded-lg overflow-hidden relative mb-2" data-id="element-270">
                {item.image ? <img src={item.image} alt={item.label} className="w-full h-full object-cover" data-id="element-271" /> : <div className="w-full h-full bg-black/5 flex items-center justify-center" data-id="element-272">
                    <ImageIcon className="w-6 h-6 text-black/20" data-id="element-273" />
                  </div>}
              </div>
              <div className="text-center" data-id="element-274">
                <h3 className="text-xs md:text-sm font-black text-black leading-tight" data-id="element-275">
                  {item.label}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}